import React, { type MouseEvent } from 'react';
import { styled, css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link.tsx';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { ISSUE_TABLE_ROW_INNER_HEIGHT } from '../../../common/constants.tsx';
import type { IssueTableIssueCol } from '../../../common/types.tsx';

type Props = {
	issue: IssueTableIssueCol;
	onIssueClicked: (issueKey: IssueKey) => void;
};

const isLeftClick = (event: MouseEvent): boolean => event.button === 0;
const isLeftClickOnly = (event: MouseEvent): boolean =>
	isLeftClick(event) && !(event.metaKey || event.ctrlKey);

export const IssueCellContent = ({ issue, onIssueClicked }: Props) => {
	const { key, typeIconUrl, summary, link } = issue;
	return (
		<Wrapper>
			<Icon src={typeIconUrl} />
			<IssueKeyLink
				href={link}
				// @ts-expect-error - TS7006 - Parameter 'evt' implicitly has an 'any' type.
				onClick={(evt) => {
					evt.preventDefault();
					if (isLeftClickOnly(evt)) {
						onIssueClicked(key);
					} else {
						// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
						window.open(link, '_blank');
					}
				}}
			>
				{key}
			</IssueKeyLink>
			<IssueSummary>{summary}</IssueSummary>
		</Wrapper>
	);
};

const truncateTextStyles = css({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${ISSUE_TABLE_ROW_INNER_HEIGHT}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 2}px`,
	marginRight: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueKeyLink = styled(Link)({
	marginRight: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const IssueSummary = styled.div(truncateTextStyles, {
	flex: 1,
});
